export default "__VITE_ASSET__C4M56VAN__"